import { useIntl } from 'react-intl'

function useErrorMessage(message) {
    const intl = useIntl()

    return intl.formatMessage({
        id: `windows.error.${message}`,
        defaultMessage: intl.formatMessage({ id: 'windows.error.somethingWrong' }),
    })
}

export default useErrorMessage
